module.exports = __webpack_public_path__ + "img/visitors-banner.046c4d18.jpg";